import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { GET_FILTERS_GROUPS } from "constants/action-types";
import siteConfig from "site-config";
import { updateEntities } from "redux-query";

export const fetchFiltersGroupsEpic = (action$, store) =>
    action$.ofType(GET_FILTERS_GROUPS.FETCH.START).switchMap(() => {
        const { scope } = store.getState();
        const request = {
            method: "GET",
            url: `${siteConfig.api}/api/v3.1/brand/${scope.brand._id}/filters/item`,
        };

        return ajax(request)
            .takeUntil(action$.ofType(GET_FILTERS_GROUPS.RESET))
            .flatMap(({ response, status, xhr }) => {
                return [
                    updateEntities({
                        filtersGroups: (currentValues) => ({
                            ...currentValues,
                            ...response.data,
                        }),
                    }),
                    {
                        payload: response.data,
                        type: GET_FILTERS_GROUPS.FETCH.SUCCESS,
                    },
                ];
            })
            .catch((error) =>
                Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: GET_FILTERS_GROUPS.FETCH.ERROR,
                    })
                )
            );
    });
